import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import type { WeaponData } from "@/lib/types/weapon";
import { WeaponImage } from "@/components/WeaponImage/WeaponImage";

interface WeaponSelectorProps {
  weapons: WeaponData[];
  selectedWeaponIndexes: number[];
  onWeaponSelect: (indexes: number[]) => void;
}

export function WeaponSelector({
  weapons,
  selectedWeaponIndexes,
  onWeaponSelect,
}: WeaponSelectorProps) {

  if (!weapons || weapons.length === 0) {
    return null;
  }

  const handleWeaponToggle = (index: number) => {
    const newIndexes = selectedWeaponIndexes.includes(index)
      ? selectedWeaponIndexes.filter((i) => i !== index)
      : [...selectedWeaponIndexes, index];
    
    // Ensure at least one weapon is always selected
    if (newIndexes.length === 0) {
      return;
    }
    
    onWeaponSelect(newIndexes);
  };

  return (
    <div className="flex flex-wrap gap-2">
      {weapons.map((weapon, index) => {
        const isSelected = selectedWeaponIndexes.includes(index);

        return (
          <div
            key={weapon.salvoIndex}
            className={`flex items-center gap-1.5 px-2 py-1 rounded border transition-all cursor-pointer ${
              isSelected
                ? "border-primary bg-primary/10"
                : "border-muted hover:border-muted-foreground/40 hover:bg-muted/50"
            }`}
            onClick={() => handleWeaponToggle(index)}
          >
            <Checkbox
              checked={isSelected}
              onCheckedChange={() => handleWeaponToggle(index)}
              id={`weapon-${index}`}
              className="h-3 w-3"
            />
            {weapon.ammo.textureId && (
              <WeaponImage
                textureId={weapon.ammo.textureId}
                alt={weapon.ammo.name}
                size="small"
                showPlaceholder={false}
              />
            )}
            <Label
              htmlFor={`weapon-${index}`}
              className="cursor-pointer text-xs font-medium whitespace-nowrap"
            >
              {weapon.ammo.name}
            </Label>
          </div>
        );
      })}
    </div>
  );
}

